import { DialogTag } from '@pixelgenau/ngx-dialog';

export const PromiseOverlayComponentDialogTag = new DialogTag<void, boolean>('promise-overlay-dialog', async () => {
    const { PromiseOverlayComponent } = await import('./promise-overlay.component');
    return PromiseOverlayComponent;
});
